import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeNotification } from '../utilsActions';
import withSnackbar from 'src/utils/Notifications/withSnackbar';

// slight clean up of: https://github.com/iamhosseindhv/notistack/issues/8

const getSnackbarMessage = message => {
  if (React.isValidElement(message)) return message;
  if (Array.isArray(message)) return message.map(getSnackbarMessage).filter(Boolean).join(', ');
  if (typeof message === 'string') return message;
  if (typeof message === 'number' || typeof message === 'boolean') return String(message);
  if (message && typeof message === 'object') return getSnackbarMessage(message.message || (message.error && message.error.message));

  return '';
};

class NotificationsRedux extends React.Component {
  state = {
    displayed: [],
  };

  setNotifications = () => {
    const { notifications, removeNotification } = this.props;
    const { displayed } = this.state;

    notifications.map(notification => {
      setTimeout(() => {
        if (displayed.filter(index => index === notification.index).length > 0) {
          return;
        }

        const { index, message, ...options } = notification;
        const snackbarMessage = getSnackbarMessage(message);

        if (snackbarMessage) {
          this.props.enqueueSnackbar(snackbarMessage, options);
        }

        this.setState({ displayed: [...this.state.displayed, index] });
        removeNotification(index);
      }, 300);

      return true;
    });
  };

  render() {
    this.setNotifications();
    return null;
  }
}

NotificationsRedux.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      message: PropTypes.any,
      variant: PropTypes.string,
    })
  ).isRequired,
  removeNotification: PropTypes.func.isRequired,
};

const mapStateToProps = ({ utils }) => ({
  notifications: utils.notifications,
});

const mapDispatchToProps = {
  removeNotification,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(NotificationsRedux));
